export const tr = {
    addMoney: 'Ödeme yap',
    archived: 'Arşivde',
    'campaign-type-content_promotion': 'İçerik promosyonu',
    'campaign-type-cpm_banner': 'Medya içerikli kampanya',
    'campaign-type-cpm_deals': 'Özel anlaşmalar',
    'campaign-type-cpm_price': 'todo',
    'campaign-type-cpm_yndx_frontpage': 'Ana sayfada medya kampanyası',
    'campaign-type-dynamic': 'Dinamik reklamlar',
    'campaign-type-internal_autobudget': 'Otomatik bütçeli kampanya',
    'campaign-type-internal_distrib': 'Dağıtım kampanyası',
    'campaign-type-internal_free': 'Ücretsiz kampanya',
    'campaign-type-mcbanner': "Arama banner'ı",
    'campaign-type-mobile_content': 'Mobil uygulama reklamı',
    'campaign-type-performance': "Akıllı banner'lar",
    'campaign-type-text': 'Metin-grafik reklamlar',
    changeCampaignDayBudget: 'Reklam kampanyasının günlük sınırlamasını değiştir',
    changeWalletDayBudget: 'Ortak hesabın sınırlamasını değiştir',
    'description-content_promotion':
        'Bu sayede, içeriği istediğiniz sitelerde yayınlayarak seçtiğiniz sorgulara göre kullanıcıları hedefleyebilirsiniz.',
    'description-cpm_banner':
        "Gösterim başına ödenen imaj reklamıdır. Banner'lar, videolar ve dijital dış mekan reklamları gibi interaktif ve ilgi çekici reklam formatlarıyla gerekli marka çağrışımlarını oluşturur.",
    'description-cpm_deals':
        'Belirli sitelerde kapsamlı imaj reklamıdır. İstediğiniz hedef kitlenin yanı sıra belirli gösterim alanlarını da seçebilirsiniz.',
    'description-cpm_yndx_frontpage':
        "Maksimum hedef kitleye ulaşın ve markanıza ilgi oluşturun. Milyonlarca kullanıcının her gün ziyaret ettiği Yandex ana sayfasında Premium banner'a sahip olun. Bin gösterim başına ödeme yapın.",
    'description-dynamic': 'Ürünlerinize özel otomatik metin reklamlarının ve ilgili sorguların oluşturulması.',
    'description-internal_autobudget': 'Otomatik bütçeli kampanya: Açıklama',
    'description-internal_distrib': 'Dağıtım kampanyası: Açıklama',
    'description-internal_free': 'Ücretsiz kampanya: Açıklama',
    'description-mcbanner':
        'Arama sonuçlarının sağında gösterilen dikkat çekici, markalı banner: Seçtiğiniz sorgulara göre hedef kitleyi çeker.',
    'description-mobile_content':
        'iOS ve Android için uygulamalarınızın kitlelere yayılmasını sağlayabilecek reklam formatıdır. En uygun fiyata maksimum kurulum sayısı elde etmenizi sağlar.',
    'description-performance': "Dinamik ürün banner'ları. Sistem otomatik olarak her kullanıcı için ayrı reklam seçer.",
    'description-text':
        'Birçok ürün ve hizmet reklamı için uygun olan genel reklamlar. Ayarlar sayesinde kampanyayı hedef kitleye göre ayarlayabilirsiniz.',
    draft: 'Taslak',
    'hint-content_promotion': "Yandex.Video'da gösterimler",
    'hint-cpm_banner': "Gösterim başına ödeme ile YRA'da gösterimler",
    'hint-cpm_deals': 'Seçilen kaynaklarda gösterimler',
    'hint-cpm_yndx_frontpage': 'Yandex ana sayfada gösterimler',
    'hint-dynamic': 'Aramada gösterimler',
    'hint-internal_autobudget': 'Otomatik bütçeli kampanya: İpuçları',
    'hint-internal_distrib': 'Dağıtım kampanyası: İpuçları',
    'hint-internal_free': 'Ücretsiz kampanya: İpuçları',
    'hint-mcbanner': 'Aramada gösterimler',
    'hint-mobile_content': 'Sadece mobil cihazlarda',
    'hint-performance': 'Ağlarda gösterimler',
    'hint-text': 'Aramada ve ağlarda gösterimler',
    isInProgress: 'İşleniyor',
    isNotRecovered: 'Yeniden kullanılamaz',
    isOverOnDate: 'Bitiş tarihi: {date}',
    moderationDenied: 'Moderasyonda reddedildi',
    moderationPending: 'Moderasyonda',
    moneyFinished: 'Bakiye yetersiz',
    noActiveBanners: 'Aktif banner yok',
    sendToModeration: 'Moderasyona gönder',
    showsWillStartAtTime: 'Gösterimlerin başlangıç saati: {time}',
    showsWillStartOnDateAtTime: 'Gösterimlerin başlangıç zamanı: {date}, {time}',
    showsWillStartOnFridayAtTime: 'Gösterim başlangıcı: Cuma {time}',
    showsWillStartOnMondayAtTime: 'Gösterim başlangıcı: Pazartesi {time}',
    showsWillStartOnSaturdayAtTime: 'Gösterim başlangıcı: Cumartesi {time}',
    showsWillStartOnSundayAtTime: 'Gösterim başlangıcı: Pazar {time}',
    showsWillStartOnThursdayAtTime: 'Gösterim başlangıcı: Perşembe {time}',
    showsWillStartOnTuesdayAtTime: 'Gösterim başlangıcı: Salı {time}',
    showsWillStartOnWednesdayAtTime: 'Gösterim başlangıcı: Çarşamba {time}',
    showsWillStartTomorrowAtTime: 'Gösterimlerin başlangıç saati yarın: {time}',
    started: 'Başlatıldı',
    stopped: 'Durduruldu',
    temporarilyPaused: 'Geçici olarak durduruldu',
    waitPayment: 'Ödeme bekliyor',
    willStartOnDate: '{date} tarihinde başlar'
};
